module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.localKeys), function(local) {
    return _c('div', [(!_vm.spec.present) ? _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(local))]) : _vm._e(), _vm._v(" "), _c(_vm._spec(local).component, {
      key: _vm._spec(local).prop,
      ref: "field",
      refInFor: true,
      tag: "component",
      attrs: {
        "name": _vm._spec(local).prop,
        "spec": _vm._spec(local),
        "model": _vm.model,
        "$parentForm": _vm.$parentForm,
        "rootModel": _vm.rootModel,
        "$rootForm": _vm.$rootForm,
        "readonly": _vm._readonly
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a08586f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-i18n.vue
// module id = 508
// module chunks = 55